import { IAdsCopilotProps } from '@bingads-webui/ads-copilot-ui';
import { useCallback, useEffect, useRef } from 'react';
import { ConnectionStatus } from 'botframework-directlinejs';

export interface IPerfMarker {
  willInit(): void;
  willFetchData(): void;
  willRender(): void;
  done: (additionalMessage?: any) => void;
  createChild: (name: string, markerOptions?: any) => IPerfMarker;
  data?: any;
  markers?: any;
}

interface IUsePerfMarkerParams {
  perfMarker: IPerfMarker;
  mode: 'expanded' | 'collapsed';
  token: string;
  onMount?: () => void;
  onConnectionStatusChange: IAdsCopilotProps['onConnectionStatusChange'];
}

export const usePerfMarker = ({
  perfMarker,
  mode,
  token,
  onMount,
  onConnectionStatusChange,
}: IUsePerfMarkerParams) => {
  const mounted = useRef(false);
  useEffect(() => {
    if (perfMarker && mode === 'expanded') {
      perfMarker.willInit();
      if (token != null) {
        perfMarker.willFetchData();
      }
    }
  }, [mode, perfMarker, token]);

  const finalOnMount = useCallback(() => {
    onMount?.();
    perfMarker?.willRender();
  }, [onMount, perfMarker]);

  const finalOnConnectionStatusChange = useCallback<NonNullable<IAdsCopilotProps['onConnectionStatusChange']>>((status) => {
    if (onConnectionStatusChange) {
      onConnectionStatusChange(status);
    }
    if (status === ConnectionStatus.Online && !mounted.current) { // The start over button will also trigger onConnectionStatusChange
      perfMarker?.done();
      mounted.current = true;
    }
  }, [onConnectionStatusChange, perfMarker]);

  return {
    onMount: finalOnMount,
    onConnectionStatusChange: finalOnConnectionStatusChange,
  };
};
